/* ==========================================================================
   MAILLOT DISTRICT — Déroulants du menu au survol
   --------------------------------------------------------------------------
   Dawn construit ses menus avec <details>/<summary> : ils s'ouvrent au clic.
   Ce fichier ajoute l'ouverture au survol sur ordinateur uniquement.

   Le clic continue de fonctionner (indispensable au clavier et sur les écrans
   tactiles), et le tiroir latéral du mobile n'est pas touché.

   ⚠️ Un déroulant n'apparaît que si l'entrée de menu possède des sous-entrées
   dans Boutique en ligne → Navigation. Sans sous-entrée, il n'y a rien à
   ouvrir : ce script reste alors sans effet.
   ========================================================================== */

(() => {
  const GRAND_ECRAN = window.matchMedia('(min-width: 990px)');
  // Petit délai à la sortie : sans lui, le menu se referme au moindre
  // passage du curseur entre le lien et le panneau.
  const DELAI_FERMETURE = 180;
  const SOURIS = window.matchMedia('(hover: hover) and (pointer: fine)');

  const brancher = () => {
    document.querySelectorAll('.header__inline-menu details').forEach((detail) => {
      if (detail.dataset.mdHover === '1') return;
      detail.dataset.mdHover = '1';

      let minuteur = null;

      const ouvrir = () => {
        if (!GRAND_ECRAN.matches) return;
        clearTimeout(minuteur);
        // On ferme les autres, sinon deux panneaux se superposent.
        detail
          .closest('.header__inline-menu')
          .querySelectorAll('details[open]')
          .forEach((autre) => {
            if (autre !== detail && !autre.contains(detail)) autre.removeAttribute('open');
          });
        detail.setAttribute('open', '');
      };

      const fermer = () => {
        if (!GRAND_ECRAN.matches) return;
        clearTimeout(minuteur);
        minuteur = setTimeout(() => detail.removeAttribute('open'), DELAI_FERMETURE);
      };

      // Un clic sur « Clubs », « Nations »… mène à la page de la rubrique.
      // Le panneau reste accessible au survol. Uniquement avec une souris :
      // sur tablette tactile (pas de survol), le premier appui ouvre toujours
      // le menu, sinon les sous-catégories deviendraient inaccessibles.
      const resume = detail.querySelector(':scope > summary[data-md-href]');
      if (resume) {
        resume.addEventListener('click', (e) => {
          if (!GRAND_ECRAN.matches || !SOURIS.matches) return;
          e.preventDefault();
          const url = resume.dataset.mdHref;
          if (e.ctrlKey || e.metaKey || e.shiftKey) window.open(url, '_blank');
          else window.location.href = url;
        });
      }

      detail.addEventListener('mouseenter', ouvrir);
      detail.addEventListener('mouseleave', fermer);
      // Le clavier garde la main : on n'interfère pas avec le focus.
      detail.addEventListener('focusin', ouvrir);
      detail.addEventListener('focusout', (e) => {
        if (!detail.contains(e.relatedTarget)) fermer();
      });
    });
  };

  brancher();

  // Écussons du méga-menu : chargés en différé pour ne rien peser au
  // chargement de la page, mais dès que la souris approche du menu — sinon
  // ils apparaîtraient avec un temps de retard à la première ouverture.
  const precharger = () => {
    document
      .querySelectorAll('.md-mega__panel img[loading="lazy"]')
      .forEach((img) => { img.loading = 'eager'; });
  };
  document.addEventListener('pointerover', (e) => {
    if (e.target.closest && e.target.closest('.header__inline-menu')) precharger();
  }, { passive: true });
  document.addEventListener('focusin', (e) => {
    if (e.target.closest && e.target.closest('.header__inline-menu')) precharger();
  });

  // L'éditeur de thème reconstruit l'en-tête à chaque modification.
  document.addEventListener('shopify:section:load', brancher);

  // En repassant sous 990 px, on ne laisse aucun panneau ouvert.
  GRAND_ECRAN.addEventListener('change', (e) => {
    if (!e.matches) {
      document
        .querySelectorAll('.header__inline-menu details[open]')
        .forEach((d) => d.removeAttribute('open'));
    }
  });
})();
